<div class="is-empty-state">
  <mat-icon color="primary"
    [svgIcon]="icon"
    [style.height]="height"
    [style.width]="width"
    [style.margin-bottom]="marginBottom"
  ></mat-icon>
  <div [ngClass]="fontSize == 'large' ? 'is-h5' : 'is-h7'">{{ title | translate }}</div>
  <div [ngClass]="fontSize == 'large' ? 'is-subtitle1' : 'is-body2 mt--5'" [style.line-height]="lineHeight" [style.padding-top]="paddingTitle">{{ subtitle | translate }}</div>
</div>
